module.exports = __webpack_public_path__ + "img/star.0b847c72.svg";